import React, { useEffect, useState, useMemo } from "react";
import ReactQuill, { Quill } from "react-quill";
import QuillBetterTable from "quill-better-table";
import { Box } from "@mui/material";

import EmailEditorTest from './EmailEditorTest';
import "react-quill/dist/quill.snow.css";

const Editor = React.memo(({ editorContent, onChange }) => {
    useEffect(() => {
        Quill.register(
            {
                "modules/better-table": QuillBetterTable,
            },
            true
        );
    }, []);

    const cleanHTML = (html) => {
        if (typeof html !== "string") return "";
        console.log(
            html
                .replace(/<p><br><\/p>/g, "")
                .replace(/ class="[^"]*"/g, "") // remove Quill formatting classes
                .trim()
        );

        return (
            html
                // .replace(/<p><br><\/p>/g, "")
                .replace(/ class="[^"]*"/g, "") // remove Quill formatting classes
                .trim()
        );
    };

    const handleSave = (html) => {
         // send to server or localStorage
         console.log('HTML content length', html.length);
       };

    return (
        <>
        <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ width: "50%", height: "25rem" }}>
                <ReactQuill
                    onChange={onChange}
                    // value={editorContent}
                    value={
                        typeof editorContent === "string" ? editorContent : ""
                    }
                    theme="snow"
                    placeholder="Start Typing..."
                    style={{ height: "100%" }}
                    modules={{
                        toolbar: [
                            [{ header: "1" }, { header: "2" }],
                            [{ list: "ordered" }, { list: "bullet" }],
                            ["bold", "italic", "underline"],
                            ["link"],
                            // ["table"],
                        ],
                    }}
                />
            </Box>

            {/* Preview  */}
            <Box
                sx={{
                    width: "50%",
                    height: "27.5rem",
                    border: 1,
                    borderColor: "#bbbcbd",
                    overflow: "auto",
                }}
            >
                {editorContent ? (
                    <div
                        className="preview-box"
                        dangerouslySetInnerHTML={{
                            __html: cleanHTML(editorContent),
                        }}
                    />
                ) : (
                    <p style={{ padding: "1rem" }}>Preview is empty</p> // Fallback text
                )}
            </Box>
            
        </Box>
        {/* <Box sx={{ display: "flex", gap: 1 }}>
            <EmailEditorTest />;
        </Box> */}
        </>
    );
});

export default Editor;
